import {
    makeStyles
} from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
    [theme.breakpoints.up('xs')]: {
        root: {
            padding: '16px',
        },
        logoContainer: {
            paddingBottom: '14px'
        },
        title: {
            fontSize: '24px',
            fontWeight: '600',
            lineHeight: '35px',
            color: '#0B1426',
            fontFamily: '"Space Grotesk", sans-serif',
            letterSpacing: '0.01em',
            marginBottom: '20px'
        },
        paragraph: {
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '150%',
            color: '#64748B',
            letterSpacing: '0.01em',
            marginBottom: '16px'
        },
        logo: {
            width: '128px',
            height: '22px'
        },
        chart: {
            width: '260px',
            height: '250px',
            paddingLeft: '0'
        },
        textContainer: {
            flexDirection: 'column-reverse',
            paddingBottom: '15px',
        }
    },
    [theme.breakpoints.up('md')]: {
        root: {
            padding: '56px 113px',
        },
        logoContainer: {
            paddingBottom: '30px'
        },
        title: {
            fontWeight: '600',
            fontSize: '44px',
            lineHeight: '150%',
            color: '#0B1426',
            fontFamily: '"Space Grotesk", sans-serif',
            letterSpacing: '0.01em',
            marginBottom: '24px'
        },
        paragraph: {
            fontWeight: 'normal',
            fontSize: '24px',
            lineHeight: '150%',
            color: '#64748B',
            letterSpacing: '0.24px',
            marginBottom: '24px'
        },
        logo: {
            width: '221px',
            height: '29px'
        },
        chart: {
            width: '440px',
            height: '380px',
            paddingLeft: '20px'
        },
        
    },
    [theme.breakpoints.up('lg')]: {
        textContainer: {
            flexDirection: 'row',
        },
        logoContainer: {
            paddingBottom: '120px'
        },
        
    },
}));